var PsrLoader = (function() {
    var cachedDOM = {};

    return {
        init: function() {
            cachedDOM.loader = $(".sell-page__loader");
        },

        start: function() {
            cachedDOM.loader.addClass("is-active");
        },

        stop: function() {
            cachedDOM.loader.removeClass("is-active");
        }
    };
})();
